import { designAssetManifest } from "../generated/designAssetManifest";

export type DesignAssetManifest = Record<string, true>;

export type DesignAssetEnv = {
  MODE: string;
  PROD: boolean;
  DEV: boolean;
  VITE_DESIGN_ASSET_BASE_URL?: string;
};

const LOCAL_DESIGN_ASSET_PREFIX = "/src/assets/design";

export function normalizeDesignAssetPath(rawPath: string): string {
  if (typeof rawPath !== "string") {
    throw new Error("设计素材路径不能为空");
  }
  let normalized = rawPath.trim().replace(/\\/g, "/");
  while (normalized.startsWith("./")) {
    normalized = normalized.slice(2);
  }
  if (!normalized) {
    throw new Error("设计素材路径不能为空");
  }
  if (
    normalized.startsWith("/") ||
    normalized.startsWith("../") ||
    normalized.includes("/../") ||
    normalized === ".."
  ) {
    throw new Error(`设计素材路径不合法: ${rawPath}`);
  }
  return normalized;
}

function normalizeBaseUrl(rawBaseUrl: string | undefined): string {
  const baseUrl = String(rawBaseUrl || "").trim();
  if (!baseUrl) {
    throw new Error("生产构建必须配置 VITE_DESIGN_ASSET_BASE_URL");
  }
  return baseUrl.replace(/\/+$/, "");
}

export function createDesignAssetResolver(
  manifest: DesignAssetManifest,
  env: DesignAssetEnv,
) {
  const baseUrl = env.PROD
    ? normalizeBaseUrl(env.VITE_DESIGN_ASSET_BASE_URL)
    : "";

  return (rawPath: string) => {
    const relativePath = normalizeDesignAssetPath(rawPath);
    if (!manifest[relativePath]) {
      throw new Error(`设计素材未登记: ${relativePath}`);
    }
    if (env.PROD) {
      return `${baseUrl}/${relativePath}`;
    }
    return `${LOCAL_DESIGN_ASSET_PREFIX}/${relativePath}`;
  };
}

export function createDesignAssetStyleResolver(
  resolveAsset: (relativePath: string) => string,
) {
  return (relativePath: string) => `url("${resolveAsset(relativePath)}")`;
}

export const designAsset = createDesignAssetResolver(
  designAssetManifest,
  import.meta.env,
);

export const designAssetStyle = createDesignAssetStyleResolver(designAsset);
